import Navbar from "@/components/Navbar";
import Analytics from "@/components/Analytics";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Location from "@/components/sections/Location";
import Specs from "@/components/sections/Specs";
import Warranties from "@/components/sections/Warranties";
import UnitModels from "@/components/sections/UnitModels";
import Gallery from "@/components/sections/Gallery";
import Partners from "@/components/sections/Partners";
import FAQSection from "@/components/sections/FAQ";
import LeadForm from "@/components/sections/LeadForm";
import Footer from "@/components/sections/Footer";
import FloatingActions from "@/components/FloatingActions";

export default function Landing() {
  return (
    <div className="landing-page bg-brand-cream text-brand-ink min-h-screen overflow-x-hidden">
      <Analytics />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Location />
        <Specs />
        <Warranties />
        <UnitModels />
        <Gallery />
        <Partners />
        <FAQSection />
        <LeadForm />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
